<template>
   <el-dialog
   class="wrapper"
  :visible.sync="dialogVisible"
  :show-close="false"
  width="30%"
  title="观看授权码"
  :before-close="handleClose">
  <div class="desc">该直播需输入授权码观看，若无授权码请联系您的理财师获取</div>
  <div class="input-wrap">
      <input type="text" v-model="authCode" placeholder="请输入授权码" class="user-input">
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" class="mouse-style" @click="confirm">确认</el-button>
  </span>
</el-dialog>
</template>
<script>
export default {
  data () {
    return {
      authCode: '',
      dialogVisible: false
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    confirm () {
      if (this.authCode === '') {
        this.$message({
          type: 'error',
          message: '请输入授权码'
        })
        return
      }
      this.$emit('confirmCode', this.authCode)
    }
  }
}
</script>
<style scoped lang="scss">
.wrapper ::v-deep .el-dialog__header{
margin:0;
padding:0;
opacity: 1;
font-size: 18px;
font-family: PingFangSC, PingFangSC-Medium;
font-weight: 500;
text-align: left;
color: #333333;
line-height: 25px;
 padding:24px;
}
.wrapper ::v-deep .el-dialog__body{
 padding:10px 24px;
}
.wrapper ::v-deep .el-dialog__footer{
  padding:0 24px 24px 24px;
  text-align:center;
  margin-top: 30px;
}
.desc {
  margin-bottom: 30px;
}
.input-wrap{
border-bottom:1px solid #eeeeee;
border-radius: 2px;
padding-bottom: 10px;
}
.user-input{
 border:none;
 outline: none;
 display:inline-block;
 width:100%;
 line-height:20px;
}
.user-input::placeholder{
  color:#CCCCCC;
}
.wrapper ::v-deep .el-dialog__footer .el-button{
padding: 10px 24px;
font-size: 14px;
width: 70%;
background: #187fc3;
border-radius: 4px;
}
</style>
